import { useState, useRef, useCallback } from 'react'
import { Form, Image, Dropdown } from 'semantic-ui-react'
import { Card, CardContent, CardGroup } from 'components/Card'
import { ColorInputWithSection } from 'components/ColorInput'

import React from 'react'
import { images } from 'packages/simplesat-config'
import uuid from 'uuid/v4'
import { getFontOption } from 'organisms/BrandSettings/utils'
import constants from 'config/constants'

export default function BrandOnboardingSettingForm({ brand, setBrand, logos = [], colors = [] }) {
  const uploadedLogo = {
    id: uuid(),
    src: null,
    isUploaded: true,
  }
  const initialState = [...logos, uploadedLogo]
  const [logosState, setLogosState] = useState(initialState)
  const uploadFileRef = useRef(null)

  const wallpaperName = [
    'Feedback Icons',
    'Emoji Sprinkles',
    'Curly Chaos',
    'Confetti Sparks',
    'Wavy Stripes',
    'Dotted Grid',
    'Zigzag Energy',
    'Playful Vibes',
    'Rainfall Stripes',
  ]

  const wallpaperOptions = [
    {
      key: 'pattern-0',
      text: 'None',
      value: 'pattern-0',
      image: null,
    },
    ...images.surveyBackgroundPatterns.map((pattern, index) => ({
      key: `${wallpaperName[index]}`,
      text: `${wallpaperName[index]}`,
      value: pattern.image,
      image: pattern.thumbnail,
    })),
  ]
  const isImageUploaded = logosState.some((item) => item.isUploaded && item.src)

  const handleChange = useCallback(
    (value, name) => {
      setBrand((prev) => ({ ...prev, [name]: value }))
    },
    [setBrand]
  )

  const handleChangeLogo = useCallback(
    (selectedLogo) => {
      setBrand((prev) => ({
        ...prev,
        logoObject: {
          src: selectedLogo.src,
          id: selectedLogo.id,
        },
      }))
    },
    [setBrand]
  )

  const handleImageUpload = useCallback(
    (e) => {
      const file = e.target.files[0]
      if (file) {
        const reader = new FileReader()
        reader.onload = function () {
          const newLogo = {
            src: reader.result,
            id: uuid(),
            isUploaded: true,
          }

          setLogosState((prevLogos) => {
            const updatedLogos = prevLogos.map((item) => (item.isUploaded ? newLogo : item))
            return updatedLogos
          })
          handleChangeLogo(newLogo)
        }
        reader.readAsDataURL(file)
      }
    },
    [handleChangeLogo]
  )

  return (
    <React.Fragment>
      <Form.Field>
        <CardGroup itemsPerRow={5} doubling className="pt-5 pb-2">
          {logosState?.map((item) => {
            const isSelected = brand.logoObject.id === item?.id

            if (!item.src) {
              return null
            }

            return (
              <LogoCard
                key={item.id}
                item={item}
                isSelected={isSelected}
                onClick={() => handleChangeLogo(item)}
              />
            )
          })}

          <UploadCard
            onClick={() => uploadFileRef.current.click()}
            uploadFileRef={uploadFileRef}
            handleImageUpload={handleImageUpload}
            isImageUploaded={isImageUploaded}
          />
        </CardGroup>
      </Form.Field>

      <Form.Group>
        <Form.Field width={8}>
          <label>Accent color</label>
          <ColorInputWithSection
            colorOptions={constants.ACCENT_COLOR_OPTIONS}
            brandColorOptions={colors
              .filter((color) => color.type === 'accent')
              .map((color) => color.hex)}
            color={brand.accentColor}
            onColorChange={(color) => handleChange(color, 'accentColor')}
          />
        </Form.Field>
        <Form.Field width={8}>
          <label>Background color</label>
          <ColorInputWithSection
            colorOptions={constants.BACKGROUND_COLOR_OPTIONS}
            brandColorOptions={colors
              .filter((color) => color.type !== 'accent')
              .map((color) => color.hex)}
            color={brand.backgroundColor}
            onColorChange={(color) => handleChange(color, 'backgroundColor')}
          />
        </Form.Field>
      </Form.Group>

      <Form.Group>
        <Form.Field width={8}>
          <label>Wallpaper</label>
          <Dropdown
            value={brand.backgroundImage || 'pattern-0'}
            selection
            fluid
            options={wallpaperOptions}
            onChange={(_, { value }) => handleChange(value, 'backgroundImage')}
          />
          {/** Customize wallpaper to the right of dropdown item -> pending bug **/}
          {/* <Dropdown.Menu>
              {wallpaperOptions.map((option) => (
                <Dropdown.Item
                  key={option.key}
                  value={option.value || ''}
                  className="!flex !items-center !justify-between"
                  onClick={(_, {value}) => handleChange(value, 'backgroundImage')}
                >
                  {option.text}
                  <Image src={option.image} floated="right" />
                </Dropdown.Item>
              ))}
            </Dropdown.Menu> */}
          {/* </Dropdown> */}
        </Form.Field>
        <Form.Field width={8}>
          <label>Font</label>
          <Dropdown
            value={brand.font}
            placeholder="Select font"
            selection
            options={getFontOption()}
            onChange={(e, { value }) => handleChange(value, 'font')}
            fluid
          />
        </Form.Field>
      </Form.Group>
    </React.Fragment>
  )
}

const LogoCard = ({ item, isSelected, onClick }) => {
  return (
    <Card className={`h-[88px] max-h-[88px]`} active={isSelected} link onClick={onClick}>
      <CardContent className="relative flex flex-row items-center justify-center">
        <Image className="max-h-[30px] object-contain" src={item.src} />
      </CardContent>
    </Card>
  )
}

const UploadCard = ({ onClick, uploadFileRef, handleImageUpload, isImageUploaded }) => (
  <Card
    className="h-[88px] max-h-[88px] bold"
    link
    onClick={onClick}
    style={{ color: 'var(--black)' }}
  >
    <CardContent className="flex flex-col items-center justify-center text-center">
      <i className={isImageUploaded ? 'fas fa-rotate-right' : 'far fa-upload'} />
      <input
        type="file"
        ref={uploadFileRef}
        onChange={handleImageUpload}
        hidden
        accept="image/png, image/jpeg, image/gif"
      />
      <p className="text-sm">{isImageUploaded ? 'Replace' : 'Upload'}</p>
    </CardContent>
  </Card>
)



// WEBPACK FOOTER //
// ./node_modules/eslint-loader??ref--0-0!./src/organisms/BrandSettings/BrandOnboardingSettingForm.js